var sb = require('@sb/util')
import api from './api.js'
var Realtime = require('@subiz/wsclient/index.js')
var cookie = require('cookie_js')
var tracking = require('./tracking.js')
cookie.defaults.path = '/'
var config = require('@sb/config')

var storage = require('./localstorage.js').default

const VIVNLang = () => import(/*webpackChunkName: "vi-VN" */ '../../lang/vi-VN.js')
const ENUSLang = () => import(/*webpackChunkName: "en-US" */ '../../lang/en-US.js')

const AlertMP3 = () => import(/*webpackChunkName: "alert-mp3" */ '../../assets/media/alert.mp3')
const AlertOGG = () => import(/*webpackChunkName: "alert-ogg" */ '../../assets/media/alert.ogg')

const MainCSS = require('!to-string-loader!css-loader!less-loader!../../assets/less/main.less')

var cssStyleDiv = document.createElement('style')
document.head.appendChild(cssStyleDiv)
cssStyleDiv.type = 'text/css'
cssStyleDiv.id = 'subiz-style'

import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

// account ID must be taken from store.user.account_id
class Store {
	/* public properties */
	isPreview = false // is offline?

	// tell if user is blocked
	// in-sync with is_banned attribute of user
	isBlocked = false

	userSetting = {}

	new_visitor = true

	user = {}
	account = {}
	accountSetting = {}

	// current device (browser info) for tracking purpose
	device = {}

	browserVisibility = 'visible'

	// map of all agents in the account
	agentM = {}

	// map of all conversations of the user
	convoM = {} // convo key => convo
	convoIdM = {} // convo key => convo id
	convoKeyM = {} // convo id => convo key

	// map of all events of all conversations of the user
	convoEventM = {} // convo key => event list

	campaignM = {} // campaign id => campaign

	fcmToken = '' // ok

	readyGate = new sb.Gate()
	convoGate = new sb.Gate(true)

	/* private properties */
	realtime
	pubsub = new sb.Pubsub()
	mask = '' // ok
	anchorM = {} // ok

	seenQueue = [] // convoid will be seen

	i18n = new VueI18n()

	lastview = {} // last widget screen
	isOpen = false // is widget currently open
	hasManuallyClosed = false // true if user has ever closed the widget
	closePreviewAt = 0

	loc = {} // user location (detect from ip)

	// check if localstorage is in the correct state, clear localstorage on any invalid state
	loadLocalStorage() {
		var valid = true

		let lastview = storage.get('lastview') || {}
		if (![undefined, '', 'chat', 'form', 'list'].includes(lastview.view)) valid = false
		if (!valid) storage.clearAll()

		this.lastview = lastview || {}
		this.isOpen = !!storage.get('isopen')
		this.hasManuallyClosed = !!storage.get('hasManuallyClosed')
		this.closePreviewAt = storage.get('close_preview_at') || 0
	}

	sendPresence = sb.throttle(() => {
		if (!this.mask || !this.user || !this.user.id) return // store not init
		api.sendPresence(this.device, this.browserVisibility === 'visible' && document.hasFocus())
	}, 1000)

	async init(accid) {
		// dont init twice
		if (sb.get(this.user, 'account_id')) return

		window.addEventListener('blur', () => this.sendPresence())
		window.addEventListener('focus', () => this.sendPresence())

		onVisibilityChange(val => {
			this.browserVisibility = val
			this.sendPresence()
		})

		this.timeDiff = 0 // server Ms - local Ms

		let mask = '' // try to find mask in cookie
		try {
			mask = cookie.get('__sbmask', '')
		} catch (e) {
			console.error(e)
		}

		let localstorageMask = storage.get('__mask')
		if (localstorageMask) {
			if (mask) {
				// check mask integrity, mask in cookie should match mask in localstorate
				// trust cookie, remove localstorage
				if (mask !== localstorageMask) storage.clearAll()
			} else mask = localstorageMask
		}

		var userId = ''
		// invalid account (may be user has changed their injected code), must recreate user
		if (mask) {
			const parts = mask.split('@')
			if (parts[0] != accid) {
				mask = ''
				clearBrowserData()
			} else {
				userId = parts[1]
			}
		}

		this.loadLocalStorage()

		if (!mask) {
			this.user = await api.createUser(accid)
			this.mask = this.user.mask
			this.user.account_id = accid // server may not return account id
		} else {
			this.new_visitor = false // for checking returning or new visitor
			this.mask = mask
			this.user.id = userId
			this.user.account_id = mask.split('@')[0]
		}
		cookie.set('__sbmask', this.mask)
		cookie.set('__sbid', this.user.id)
		storage.set('__mask', this.mask)

		if (this.realtime) this.realtime.stop()
		this.realtime = new Realtime(config.RealtimeURL, {user_mask: this.mask})
		this.realtime.onEvent(this.onWs.bind(this))
		this.realtime.onInterrupted(this.onRealtimeDead.bind(this))

		this.setDevice(tracking.getDeviceInfo())

		// periodically send seen
		const _seenInterval = setInterval(() => {
			// deduplicate
			this.seenQueue = [...new Set(this.seenQueue)]

			sb.map(this.seenQueue, convokey => {
				var events = this.convoEventM[convokey]
				if (!events) return
				if (sb.size(events) === 0) return

				// find the last message send
				events = sb.filter(events, ev => ev.type === 'message_sent')
				var lastmsgsent = events[sb.size(events) - 1]
				if (!lastmsgsent) return

				let pongs = sb.get(lastmsgsent, 'data.message.pongs', [])
				var seen = sb.find(pongs, pong => pong.type === 'seen' && pong.member_id === this.user.id)

				if (seen) return

				var convoid = sb.convoOfEv(lastmsgsent)
				// fake a pong message from server
				this.onWs({
					id: 'evfff' + sb.randomString(36),
					account_id: this.user.account_id,
					created: new Date().getTime(),
					type: 'message_pong',
					by: {id: this.user.id, client_id: 'widget', type: 'user'},
					data: {
						message: {
							conversation_id: convoid,
							_conversation_key: convokey,
							id: lastmsgsent.id,
							pongs: [{member_id: this.user.id, type: 'seen', created: new Date().getTime(), _fake: true}],
						},
					},
				})

				// ignore sending message
				if (lastmsgsent.id === sb.getMsgField(lastmsgsent, 'idempotency')) return

				// send seen
				api.markAsSeen(convoid, lastmsgsent.id)
			})

			this.seenQueue = []
		}, 5000)

		// try to get Google Analytics tracking id and client id by periodically checking it after an interval
		const _gaInterval = setInterval(function() {
			var dev = tracking.getDeviceInfo()
			if (!dev.ga_tracking_ids || !dev.ga_client_id) return
			clearInterval(_gaInterval)
			store.setDevice(dev)
		}, 2000)

		// load alert sound
		try {
			const sound = new window.Audio()
			// sound.addEventListener('canplaythrough', () => rs(sound), false)
			this.alertSound = await AlertMP3()
			if (!document.createElement('audio').canPlayType('audio/mpeg')) {
				this.alertSound = await AlertOGG()
			}
			sound.src = this.alertSound.default
		} catch (e) {
			console.log('SOUND ERR', e)
		}

		var userid = this.user.id
		await this.realtime.subscribe([
			`conversation_state_updated.account.${accid}.user.${userid}`,
			`conversation_joined.account.${accid}.user.${userid}`,
			`conversation_left.account.${accid}.user.${userid}`,
			`conversation_typing.account.${accid}.user.${userid}`,
			`message_sent.account.${accid}.user.${userid}`,
			`conversation_pending.account.${accid}.user.${userid}`,
			`user_info_updated.account.${accid}.user.${userid}`,
			`message_pong.account.${accid}.user.${userid}`,
			`conversation_rating_requested.account.${accid}.user.${userid}`,
			`conversation_rated.account.${accid}.user.${userid}`,
		])
		await this.resync(this.user.account_id, this.user.id)
		this.readyGate.open()

		setInterval(() => {
			if (this.isPreview) return
			if (this.isBlocked) return
			let hasFocus = document.hasFocus()
			this.sendPresence()
		}, 25 * 1000) // dont bother delete this
	}

	// turn previewing mode on, widget is now just for demo
	// we created previewing mode to display widget inside the dashboard
	preview() {
		this.isPreview = true
		this.pubsub.publish('state.isPreview', true)
	}

	setDevice(dev) {
		this.device = dev
		this.pubsub.publish('state.device', dev)
	}

	// set user info, keeping old user id and account id
	async setUser(user) {
		if (!user) return
		await this.readyGate.entry()
		if (this.isPreview) return
		this._setUser(user)
		await api.updateUser(user)
	}

	_setUser(user) {
		var oldAccid = this.user.account_id
		var oldId = this.user.id

		// merge attr
		sb.each(user.attributes, newattr => {
			this.user.attributes = sb.filter(this.user.attributes, oldattr => oldattr.key !== newattr.key)
		})
		this.user.attributes = this.user.attributes.concat(user.attributes)
		this.user.account_id = oldAccid
		this.user.id = oldId

		this.isBlocked = sb.isUserBanned(this.user)

		this.pubsub.publish('state.user', this.user)
		this.pubsub.publish('state.isBlocked', this.isBlocked)
	}

	setCss(css) {
		if (cssStyleDiv.styleSheet) {
			// This is required for IE8 and below.
			cssStyleDiv.styleSheet.cssText = css
		} else {
			cssStyleDiv.innerHTML = ''
			cssStyleDiv.appendChild(document.createTextNode(css))
		}
	}

	async setSetting(setting) {
		if (!setting) return
		await this.readyGate.entry()
		this._setSetting(setting)
	}

	async _setSetting(setting) {
		setting = sb.cloneDeep(setting)
		fixMissingSetting(setting)

		var languageModified =
			this.accountSetting.language !== sb.get(setting, 'account_setting.language') ||
			this.accountSetting.custom_language_url !== sb.get(setting, 'account_setting.custom_language_url')

		this.userSetting = setting
		this.accountSetting = setting.account_setting
		delete setting.account_setting

		if (setting.account) {
			this.account = setting.account
			delete setting.account
			this.pubsub.publish('state.account', this.account)
		}

		var agents = sb.get(this.accountSetting, 'agents', [])
		delete this.accountSetting.agents
		if (agents.length > 0) {
			this.agentM = {}
			sb.map(agents, agent => {
				this.agentM[agent.id] = agent
			})
			this.pubsub.publish('state.agentM', this.agentM)
		}

		let campaigns = sb.get(this.userSetting, 'campaigns', [])
		delete this.userSetting.campaigns
		if (campaigns.length > 0) {
			this.campaignM = {}
			sb.map(campaigns, cam => {
				this.campaignM[cam.id] = cam
			})
			this.pubsub.publish('state.campaignM', this.campaignM)
		}

		let outcss = replaceCssVariable(MainCSS, this.accountSetting)
		this.setCss(outcss)

		if (languageModified) await this.setLanguage(this.accountSetting.language, this.accountSetting.custom_language_url)

		this.pubsub.publish('state.userSetting', this.userSetting)
		this.pubsub.publish('state.accountSetting', this.accountSetting)
	}

	async setFcmToken(token) {
		if (!token) return
		this.fcmToken = token
		this.pubsub.publish('state.fcmToken', token)
		await api.updateFcmToken(token)
	}

	async removeFcmToken() {
		if (this.isPreview) return
		if (!this.fcmToken) return
		var fcmtoken = this.fcmToken
		this.fcmToken = ''
		this.pubsub.publish('state.fcmToken', '')
		await api.deleteFcmToken(fcmtoken)
	}

	bind(vue, obj) {
		var out = {}
		let subs = []
		sb.each(obj, key => {
			var path = obj[key]
			// intial value
			out[key] = sb.cloneDeep(sb.get(this, key))

			// watch change
			var sub = this.pubsub.on('state.' + key, value => {
				vue[key] = value // change vue prop
				out[key] = value
				vue.$forceUpdate()
			})
			subs.push(sub)
		})

		// unwatch after destroyed
		vue.$once('hook:beforeDestroy', () => subs.map(sub => this.pubsub.un(sub)))
		return out
	}

	// change current language setting
	// accLangCode: en-US || vi-VN
	async setLanguage(accLangCode, custom_language_url, customLangData) {
		var langCode = accLangCode || ''
		if (!sb.isValidLanguageCode(langCode)) langCode = navigator.language

		// download base lang
		var deflangfunc = langCode === 'vi-VN' || langCode === 'vi' ? VIVNLang : ENUSLang
		var lang = (await deflangfunc()).default

		const customLangURL = sb.replaceFileUrl(custom_language_url)
		// only use custom language if the current language matched predefined lang code in account setting
		customLangData = customLangData || {}

		if (customLangURL && accLangCode === langCode) {
			const customLangFromUrl = await api.get(customLangURL)
			customLangData = Object.assign({}, customLangFromUrl, customLangData)
		}

		lang = Object.assign({}, lang, customLangData)
		this.i18n.setLocaleMessage(langCode, lang)
		this.i18n.locale = langCode
	}

	sendEventToThirdParty(category, action, label) {
		tracking.sendEventToThirdParty(category, action, label)
	}

	// send the content view, the first presence and record domain
	async track() {
		if (this.isPreview) return
		await api.sendContent(this.device, location.href, document.title)
		api.recordDomain({a: this.user.account_id, u: this.user.id, p: location.href})
		this.sendPresence()
	}

	async fetchConvo(convoKey) {
		if (this.isPreview) return
		await this.convoGate.entry()

		let convo = await api.getConversation(this.convoIdM[convoKey] || convoKey)
		convo._key = convoKey
		this.convoM[convoKey] = convo
		this.convoIdM[convoKey] = convo.id
		this.convoKeyM[convo.id] = convoKey

		await this.fetchOlder(convoKey)
		return convo
	}

	// manually set list of conversation
	// for development only
	_setConvos(convos) {
		this.convoM = {}
		convos.map(convo => {
			convo._key = convo.id
			this.convoM[convo.id] = convo
			this.convoIdM[convo.id] = convo.id
			this.convoKeyM[convo.id] = convo.id
			this.pubsub.publish('state.convoM', this.convoM, convo.id)
		})
	}

	onRealtimeDead() {
		if (this.isPreview) return
		this.resync(this.user.account_id, this.user.id)
	}

	async onWs(ev) {
		if (!ev || !ev.type) return
		const INTEGRATION_ID = sb.getIntegrationId(this.user.account_id)

		if (sb.startsWith(ev.type, 'conversation_')) {
			let convoId = sb.get(ev, 'data.conversation.id', '')
			if (!convoId) return
			let convo = this.lookupConvo(convoId)
			if (!sb.get(convo, 'id')) {
				convo = await api.getConversation(convoId)
			}
			const integrationId = sb.get(convo, 'integration.id', '')
			if (!integrationId || integrationId !== INTEGRATION_ID) return
		}

		// ignore if event come from another integration
		if (sb.startsWith(ev.type, 'message_')) {
			let convoId = sb.get(ev, 'data.message.conversation_id', '')
			if (!convoId) return
			let convo = this.lookupConvo(convoId)
			if (!sb.get(convo, 'id')) {
				convo = await api.getConversation(convoId)
			}

			let integrationId = sb.get(convo, 'integration.id', '')
			console.log('INTE 0', integrationId)
			if (!integrationId) integrationId = sb.get(ev, 'data.message.integration_id', '')
			console.log('INTE 1', integrationId)
			if (!integrationId || integrationId !== INTEGRATION_ID) return
		}
		let convoKey = sb.convoKeyOfEv(ev)
		let convoId = sb.convoOfEv(ev)
		if (!convoKey) convoKey = this.convoKeyM[convoId] || convoId
		if (!convoKey && convoId) {
			convoKey = convoId // use convo id as convo key
			this.convoIdM[convoKey] = convoId
			this.convoKeyM[convoId] = convoKey
		}

		sb.convoKeyToEv(convoKey, ev) // inject convo key
		this.wsConvoEvent(ev)
		this.wsUserInfoUpdated(ev)
		this.wsConversationJoined(ev)
	}

	async restConvoEvent(ev) {
		if (!CONVOEVENTS.includes(ev.type)) return

		sb.backwardCompatibleEv(ev, this.user)

		let convoKey = sb.convoKeyOfEv(ev)

		if (!this.convoM[convoKey]) this.convoM[convoKey] = {_key: convoKey}

		if (ev.type === 'conversation_state_updated') {
			let convo = sb.get(ev, 'data.conversation')
			let oldConvo = this.lookupConvo(convoKey)
			if (!sb.get(convo, 'id')) {
				oldConvo = await api.getConversation(convo.id)
			}
			convo = Object.assign({}, oldConvo, convo)
			sb.get(this.convoM, `${convoKey}`)
			this.convoM[convoKey] = convo
		}

		if (ev.type === 'message_pong') {
			// update pongged message
			var msgid = sb.get(ev, 'data.message.id')
			if (!sb.get(this.convoEventM, `${convoKey}.${msgid}.data.message`)) return

			var pongs = sb.get(this.convoEventM, `${convoKey}.${msgid}.data.message.pongs`, [])
			pongs = pongs.concat(sb.get(ev, 'data.message.pongs', []))
			sb.set(this.convoEventM, `${convoKey}.${msgid}.data.message.pongs`, pongs)
		}

		if (ev.type === 'message_sent') {
			// update last message of convo
			sb.set(this.convoM, `${convoKey}.last_message`, sb.get(ev, 'data.message') || {})
			sb.set(this.convoM, `${convoKey}.last_message_id`, ev.id)
		}

		// dont store pong and typing
		if (ev.type !== 'message_pong' && ev.type !== 'conversation_typing') {
			sb.set(this.convoEventM, convoKey + '.' + ev.id, ev)
		}

		this.handleFormSubmit(convoKey, ev)

		this.pubsub.publish('state.convoM', this.convoM)
		this.pubsub.publish('state.convoEventM', this.convoEventM, convoKey)
		this.pubsub.publish('events', ev)
	}

	wsConvoEvent(ev) {
		this.restConvoEvent(ev)
		if (ev.type !== 'message_sent' || sb.get(ev, 'by.id') === this.user.id) return
		this.sendEventToThirdParty('SUBIZ Chat', 'Received', 'User')
	}

	handleFormSubmit(convoKey, ev) {
		// find form submit
		if (ev.type !== 'message_sent') return
		// has form submit
		let formSubmits = []
		let attachments = sb.get(ev, 'data.message.attachments') || []
		sb.each(attachments, att => {
			if (!att) return
			if (att.type !== 'form_submit') return
			formSubmits.push(att.form_submit)
		})

		if (sb.size(formSubmits) === 0) return
		sb.each(formSubmits, submit => {
			let formev = sb.get(this.convoEventM, convoKey + '.' + submit.form_message_id)
			if (!formev) return

			// find form attachment
			let forms = sb.filter(sb.get(formev, 'data.message.attachments'), att => {
				if (!att) return false
				if (att.type !== 'form' && att.type !== 'ask_info_form') return false
				return true
			})

			sb.each(forms, form => {
				form = form.form
				form._submitted = true
				sb.each(form.fields, formfield => {
					sb.each(submit.fields, submitfield => {
						if (formfield.name !== submitfield.name) return
						if (formfield.default_answer) return

						formfield.default_answer = submitfield.value
					})
				})
			})

			if (sb.size(forms) > 0) this.pubsub.publish('state.convoEventM', this.convoEventM, convoKey)
		})
	}

	wsUserInfoUpdated(ev) {
		if (ev.type !== 'user_info_updated') return
		let user = sb.cloneDeep(this.user)
		let attrs = sb.get(ev, 'data.user.attributes') || []
		for (let attr of attrs) {
			sb.setUserAttr(user, attr)
		}
		this._setUser(user)
	}

	async wsConversationJoined(ev) {
		// server doesn't send events before conversation_joined occur
		// so re-get events of this conversation to ensure we dont miss any event
		if (ev.type !== 'conversation_joined') return
		var convoKey = sb.convoKeyOfEv(ev)
		if (!convoKey) return

		let convo = this.lookupConvo(convoKey)
		if (!sb.get(convo, 'id')) {
			let convo = await this.fetchConvo(convoKey)
		}

		if (!convo) return
		this.pubsub.publish('state.convoM', this.convoM, convoKey)
	}

	typing(convoKey) {
		if (!convoKey) return
		if (this.isPreview) return
		if (this.convoIdM[convoKey]) this._typing(this.convoIdM[convoKey] || convoKey)
	}

	_typing = sb.throttle(convoid => api.sendTyping(convoid), 3000)

	updateConvoInfo() {}

	endConvo(convoKey) {
		return api.end(this.convoIdM[convoKey] || convoKey)
	}

	startConvo(req) {
		if (this.isPreview) return
		let key = sb.randomString(36)
		this._startConvo(key, req) // dont wait
		let convo = {_key: key, created: new Date().getTime()}
		this.convoM[key] = convo
		return convo
	}

	lookupConvo(id) {
		return this.convoM[id] || this.convoM[this.convoIdM[id]] || this.convoM[this.convoKeyM[id]]
	}

	async _startConvo(convoKey, req) {
		this.convoGate.close()
		let convo = await api.start(req)
		convo._key = convoKey
		this.convoIdM[convoKey] = convo.id
		this.convoKeyM[convo.id] = convoKey
		this.convoM[convoKey] = convo

		this.pubsub.publish('state.convoIdM', this.convoIdM)
		this.pubsub.publish('state.convoKeyM', this.convoKeyM)
		this.pubsub.publish('state.convoM', this.convoM)
		this.convoGate.open()
	}

	// fetch older messages of convo
	async fetchOlder(convoKey) {
		let convoid = this.convoIdM[convoKey] || ''
		if (!convoid) return
		let events = await api.getMessages(convoid, -100, this.anchorM[convoKey] || '')
		sb.map(events, ev => {
			sb.convoKeyToEv(convoKey, ev)
			if (ev.type !== 'message_pong' && ev.type !== 'conversation_typing') {
				sb.set(this.convoEventM, convoKey + '.' + ev.id, ev)
			}
		})
		const anchor = sb.get(events, '0.id')
		this.anchorM[convoKey] = anchor
		this.pubsub.publish('state.convoEventM', this.convoEventM, convoKey)
		this.pubsub.publish('state.anchorM', this.anchorM, convoKey)
	}

	async sendConvoEventData(convoKey, type, data) {
		if (this.isPreview) return
		var idempotency = sb.randomString(36)

		var event = {
			id: idempotency,
			by: {id: this.user.id, type: 'user'},
			data,
			type,
			created: new Date().getTime(),
		}
		sb.convoKeyToEv(convoKey, event) // inject convo key

		this.onWs(event) // display sending

		await this.convoGate.entry()
		let convoId = this.convoIdM[convoKey] || convoKey

		var restev = await api.sendConvoEvent(convoId, event)

		// delete temp ev
		delete this.convoEventM[convoKey][idempotency]
		sb.convoKeyToEv(convoKey, restev) // inject convo key
		this.onWs(restev)
	}

	async sendConvoEvent(convoKey, message) {
		if (this.isPreview) return
		var idempotency = sb.randomString(36)

		var event = {
			id: idempotency,
			by: {id: this.user.id, type: 'user'},
			data: {message},
			type: 'message_sent',
			created: new Date().getTime(),
		}

		// set chain id for facebook
		message._conversation_key = convoKey

		// set idempotency
		sb.setMsgField(event, 'idempotency', idempotency)
		this.onWs(event) // display sending

		await this.convoGate.entry()
		let convoId = this.convoIdM[convoKey] || convoKey
		message.conversation_id = convoId
		var restev
		try {
			console.log("SENDING", convoId, event)
			restev = await api.sendConvoEvent(convoId, event)
		} catch (e) {
			console.log("MUST REFRESH", e, convoId)
			// conversation may end, must refresh
			let convo = await store.fetchConvo(convoId)
			this.pubsub.publish('state.convoM', this.convoM, convoId)
		}
		sb.convoKeyToEv(convoKey, restev) // inject convo key
		this.onWs(restev)
	}

	uploadToS3(files) {
		return api.uploadToS3(files)
	}

	onTime(cb) {
		return this.pubsub.on('time', cb)
	}

	un(subid) {
		return this.pubsub.un(subid)
	}

	onConvoEvent(vue, cb) {
		var sub = this.pubsub.on('events', cb)
		vue.$once('hook:beforeDestroy', () => this.pubsub.un(sub))
		return sub
	}

	seenConvo(key) {
		if (!key) return
		this.seenQueue.push(key)
	}

	now() {
		// millisecond on server
		return new Date().getTime() + this.timeDiff
	}

	onApiError(code) {
		if (
			!(
				code === 'wrong_account_in_credential' ||
				code === 'account_not_found' ||
				code === 'invalid_credential' ||
				code === 'wrong_user_in_credential' ||
				code === 'user_not_found' ||
				code === 'invalid_mask' ||
				code === 'user_is_blocked' ||
				code === 'domain_is_not_whitelisted'
			)
		) {
			return
		}

		if (code !== 'user_is_blocked' && code !== 'domain_is_not_whitelisted') {
			this.isBlocked = true
			this.pubsub.publish('state.isBlocked', this.isBlocked)
			return
		}
	}

	async fetchUserSetting() {
		var userSetting = await api.getUserSetting()
		await this._setSetting(userSetting)
		this._setUser(this.userSetting.user)
		delete this.userSetting.user
	}

	// resubscribe ws and fetch new event from api
	async resync(accid, userid) {
		if (this.isPreview) return
		var vals = await Promise.all([
			(async () => {
				await this.fetchUserSetting()
			})(),
			(async () => {
				// refetch convo
				var result = await api.listConversations()

				let convos = sb.get(result, 'conversations', [])
				this.convoM = {}
				convos.map(convo => {
					let key = this.convoKeyM[convo.id]
					if (!key) key = convo.id
					convo._key = key
					this.convoM[key] = convo
					this.convoIdM[key] = convo.id
					this.pubsub.publish('state.convoM', this.convoM, key)
				})

				var ops = sb.map(convos, convo => ({
					method: 'GET',
					url: `/4.0/conversations/${convo.id}/messages?limit=-20&x-user-mask=${this.mask}`,
				}))
				result = await api.sendBatchRequest('conversations-events', ops)
				this.convoEventM = {}
				this.anchorM = {}
				sb.map(convos, (convo, i) => {
					const status = sb.get(result, i + '.status', 0)
					if (status !== 200) return

					let events = sb.get(result, i + '.body', [])

					events = sb.orderBy(events, 'created', 'asc')

					let convoKey = convo._key
					sb.map(events, ev => {
						sb.convoKeyToEv(convoKey, ev)
						this.restConvoEvent(ev)
					})
					const anchor = sb.get(events, '0.id')
					this.anchorM[convoKey] = anchor

					this.pubsub.publish('state.anchorM', this.anchorM, convoKey)
				})
			})(),
		])
	}

	setHasManuallyClosed() {
		this.hasManuallyClosed = true
		storage.set('hasManuallyClosed', true)
	}

	setIsOpen(isopen) {
		this.isOpen = isopen
		storage.set('isopen', this.isOpen)
	}

	closePreview() {
		this.closePreviewAt = new Date().getTime()
		storage.set('close_preview_at', this.closePreviewAt)
	}

	setLastview(view, opts) {
		this.lastview = {view, opts}
		storage.set('lastview', this.lastview)
	}

	async fetchLocation() {
		if (sb.size(this.loc) === 0) {
			this.loc = await api.getGeoIP()
		}
		return this.loc
	}

	async sendImpression(campid, triggerType) {
		let data = {
			account_id: sb.get(this.user, 'account_id'),
			campaign_id: campid,
			user_id: sb.get(this.user, 'id'),
			url: window.location.href,
			device: this.device,
			by_trigger: triggerType,
		}
		return await api.sendImpression(data)
	}

	async sendConversion(campid, triggerType, submission, impressionToken) {
		let data = {
			account_id: sb.get(this.user, 'account_id'),
			campaign_id: campid,
			user_id: sb.get(this.user, 'id'),
			url: window.location.href,
			device: this.device,
			by_trigger: triggerType,
			submission,
			impression_token: impressionToken,
		}
		return await api.sendConversion(data)
	}

	async setGoalReached(campid) {
		let data = {
			account_id: sb.get(this.user, 'account_id'),
			campaign_id: campid,
			user_id: sb.get(this.user, 'id'),
			status: 'goal_reached',
		}
		return await api.setGoalReached(data)
	}
}

function getOffsetMin(tz = '+07:00') {
	var [hour, min] = tz.split(':')
	hour = parseInt(hour)
	min = parseInt(min)

	if (hour < -12 || hour > 12) {
		hour = 0
	}

	if (min < 0 || min >= 60) {
		min = 0
	}

	return hour * 60 + min
}

function clearBrowserData() {
	const cookies = cookie.all() || {}
	sb.each(cookies, (v, k) => {
		if ((k || '').startsWith('__sb')) cookie.remove(k)
	})

	storage.clearAll()
}

// set default value if not exists
function fixMissingSetting(setting) {
	// account logo
	if (!sb.get(setting, 'account.logo_url')) {
		sb.set(setting, 'account.logo_url', 'https://filev4.subiz.com/fiqpezhkmeyesdscyetk-default_logo.jpg')
	}

	if (sb.get(setting, 'account_setting.desktop_button.background_image_url')) {
		setting.account_setting.desktop_button.background_image_url = sb.replaceFileUrl(
			setting.account_setting.desktop_button.background_image_url,
		)
	}
	if (sb.get(setting, 'account_setting.desktop_button.background_mask_url')) {
		setting.account_setting.desktop_button.background_mask_url = sb.replaceFileUrl(
			setting.account_setting.desktop_button.background_mask_url,
		)
	}

	if (sb.get(setting, 'account_setting.mobile_button.background_image_url')) {
		setting.account_setting.mobile_button.background_image_url = sb.replaceFileUrl(
			setting.account_setting.mobile_button.background_image_url,
		)
	}
	if (sb.get(setting, 'account_setting.mobile_button.background_mask_url')) {
		setting.account_setting.mobile_button.background_mask_url = sb.replaceFileUrl(
			setting.account_setting.mobile_button.background_mask_url,
		)
	}
}

const CONVOEVENTS = [
	`conversation_state_updated`,
	`conversation_joined`,
	`conversation_untagged`,
	`conversation_tagged`,
	`conversation_typing`,
	`conversation_state_updated`,
	`conversation_joined`,
	`conversation_invited`,
	`message_sent`,
	`message_updated`,
	`message_pong`,
	`conversation_member_typing`,
	`conversation_typing`,
	`conversation_rating_requested`,
	`conversation_rated`,
]

var store = new Store()
api.setStore(store)
api.onError = store.onApiError.bind(store)

// expose store for debugging purpose
window.sbz_store = store

export default store

// tokenizy(['hello XX andy XX go'], 'XX')
// => ['hello ', {type: 'XX'},' andy ', {type: 'XX'}, ' go']
function tokenize(arr, token) {
	if (!arr || !arr.length) return []
	var out = []

	for (let i = 0; i < arr.length; i++) {
		var item = arr[i]
		if (typeof item !== 'string') {
			out.push(item)
			continue
		}
		var ts = item.split(token)
		for (let i = 0; i < ts.length; i++) {
			out.push(ts[i])
			out.push({type: token})
		}
		out.pop()
	}

	return out
}

const DEF_CHAT_BUTTON_BACKGROUND_IMAGE_URL = 'https://file.mysubiz.com/bubble_11.svg'

const DEFVAL = {
	primary_color: '#0265FF',
	secondary_color: '#555555',
	background: 'linear-gradient(280.16deg, #0053d3 22.03%, #0265ff 78.2%)',
	text_color: 'white',
	width: 375,
	height: 705,
	window_mode: 'mini',
	desktop_button: {
		width: 0.3, // 0 would be left empty, causing invalid css (by less) ??
		height: 0.3,
		border_radius: '100%',
		background_mask_url: DEF_CHAT_BUTTON_BACKGROUND_IMAGE_URL,
		margin_x: 0.3,
		margin_y: 0.3,
	},
	mobile_button: {
		width: 0.3,
		height: 0.3,
		border_radius: '100%',
		background_mask_url: DEF_CHAT_BUTTON_BACKGROUND_IMAGE_URL,
		margin_x: 0.3,
		margin_y: 0.3,
	},
}

function replaceCssVariable(css, setting) {
	// tokenize
	var tokens = [css]
	tokens = tokenize(tokens, "'@primary_color'")
	tokens = tokenize(tokens, '@esc-primary-color-esc')
	tokens = tokenize(tokens, "'@secondary_color'")
	tokens = tokenize(tokens, "'@background'")
	tokens = tokenize(tokens, "'@text_color'")
	tokens = tokenize(tokens, "'@width'")
	tokens = tokenize(tokens, "'@height'")
	tokens = tokenize(tokens, "'@desktop_button.width'")
	tokens = tokenize(tokens, "'@desktop_button.height'")
	tokens = tokenize(tokens, "'@desktop_button.background'")
	tokens = tokenize(tokens, "'@desktop_button.border_radius'")
	//tokens = tokenize(tokens, "'@desktop_button.background_image_url'")
	//tokens = tokenize(tokens, "'@desktop_button.background_mask_url'")
	tokens = tokenize(tokens, "'@desktop_button.margin_x'")
	tokens = tokenize(tokens, "'@desktop_button.margin_y'")
	tokens = tokenize(tokens, "'@mobile_button.width'")
	tokens = tokenize(tokens, "'@mobile_button.height'")
	tokens = tokenize(tokens, "'@mobile_button.background'")
	tokens = tokenize(tokens, "'@mobile_button.border_radius'")
	//tokens = tokenize(tokens, "'@mobile_button.background_image_url'")
	//tokens = tokenize(tokens, "'@mobile_button.background_mask_url'")
	tokens = tokenize(tokens, "'@mobile_button.margin_x'")

	tokens = tokenize(tokens, "'@mobile_button.margin_y'")

	var ret = []
	for (var i = 0; i < tokens.length; i++) {
		var item = tokens[i]
		if (typeof item === 'string') {
			ret.push(item)
			continue
		}

		if (item.type === '@esc-primary-color-esc') {
			var val = sb.get(setting, 'primary_color') || sb.get(DEFVAL, 'primary_color')
			ret.push(encodeURIComponent(norm(val)))
			continue
		}

		// remove @''
		var path = item.type.substr(2, item.type.length - 3)
		var val = sb.get(setting, path) || sb.get(DEFVAL, path) || ''
		val = norm(val)
		if (
			[
				'mobile_button.width',
				'mobile_button.height',
				'mobile_button.margin_x',
				'mobile_button.margin_y',
				'desktop_button.width',
				'desktop_button.height',
				'desktop_button.margin_x',
				'desktop_button.margin_y',
				'width',
				'height',
			].includes(path)
		)
			val += 'px'

		// mode is full
		if (path === 'height' && sb.get(setting, 'window_mode') === 'full') {
			ret.push('100%')
			continue
		}
		ret.push(val)
	}

	return ret.join('')
}

function norm(val) {
	if (typeof val === 'string' || val instanceof String) val = val.trim().replace(/;+$/, '')
	return val
}

function onVisibilityChange(cb) {
	var hidden = 'hidden'

	// Standards:
	if (hidden in document) document.addEventListener('visibilitychange', onchange)
	else if ((hidden = 'mozHidden') in document) document.addEventListener('mozvisibilitychange', onchange)
	else if ((hidden = 'webkitHidden') in document) document.addEventListener('webkitvisibilitychange', onchange)
	else if ((hidden = 'msHidden') in document) document.addEventListener('msvisibilitychange', onchange)
	// IE 9 and lower:
	else if ('onfocusin' in document) document.onfocusin = document.onfocusout = onchange
	// All others:
	else window.onpageshow = window.onpagehide = window.onfocus = window.onblur = onchange

	function onchange(evt) {
		var v = 'visible',
			h = 'hidden',
			evtMap = {
				focus: v,
				focusin: v,
				pageshow: v,
				blur: h,
				focusout: h,
				pagehide: h,
			}

		evt = evt || window.event
		if (evt.type in evtMap) cb(evtMap[evt.type])
		else cb(this[hidden] ? 'hidden' : 'visible')
	}

	// set the initial state (but only if browser supports the Page Visibility API)
	if (document[hidden] !== undefined) onchange({type: document[hidden] ? 'blur' : 'focus'})
}
